var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 28C4.5 14.7452 15.2452 4 28.5 4C41.7548 4 52.5 14.7452 52.5 28C52.5 41.2548 41.7548 52 28.5 52C15.2452 52 4.5 41.2548 4.5 28Z",
    fill: "#FEF0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 23.9992V27.9992M28.4998 31.9992H28.5098M26.7898 18.8592L18.3198 32.9992C18.1451 33.3017 18.0527 33.6445 18.0518 33.9937C18.0508 34.343 18.1413 34.6864 18.3142 34.9898C18.4871 35.2931 18.7365 35.546 19.0375 35.7231C19.3385 35.9002 19.6806 35.9954 20.0298 35.9992H36.9698C37.319 35.9954 37.6611 35.9002 37.9621 35.7231C38.2631 35.546 38.5124 35.2931 38.6854 34.9898C38.8583 34.6864 38.9488 34.343 38.9478 33.9937C38.9468 33.6445 38.8544 33.3017 38.6798 32.9992L30.2098 18.8592C30.0315 18.5653 29.7805 18.3223 29.481 18.1537C29.1814 17.9851 28.8435 17.8965 28.4998 17.8965C28.156 17.8965 27.8181 17.9851 27.5186 18.1537C27.2191 18.3223 26.968 18.5653 26.7898 18.8592Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48C17.4543 48 8.5 39.0457 8.5 28H0.5C0.5 43.464 13.036 56 28.5 56V48ZM48.5 28C48.5 39.0457 39.5457 48 28.5 48V56C43.964 56 56.5 43.464 56.5 28H48.5ZM28.5 8C39.5457 8 48.5 16.9543 48.5 28H56.5C56.5 12.536 43.964 0 28.5 0V8ZM28.5 0C13.036 0 0.5 12.536 0.5 28H8.5C8.5 16.9543 17.4543 8 28.5 8V0Z",
    fill: "#FFFAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9c3649a224d69e2bb1d828431efedacb.svg";
export { ForwardRef as ReactComponent };